import React from 'react';

function StatsComponent(props) {
    const stats = [
        {count: "5k" ,label: "Active Students"},
        {count: "10+" ,label: "Mentors"},
        {count: "200+" ,label: "Courses"},
        {count: "50+" ,label: "Awards"},
    ]
    return (
        <div className='bg-richblack-800 flex justify-center h-[10rem]'>
            <div className='flex justify-center gap-x-32 max-[450px]:gap-x-4'>
                {
                    stats.map((data,index)=> {
                        return (
                            <div className='flex flex-col justify-center items-center' key={index}>
                                <h1 className='text-richblack-25 text-3xl max-[450px]:text-xl'>{data.count}</h1>
                                <p className='text-richblack-50'>{data.label}</p>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

export default StatsComponent;